import { i18nKeys } from 'translationTypes'
import i18n from '../../../i18n'

export default {
  vehicleExplanation: () =>
    i18n.t(i18nKeys.backgroundCheck__vehicleExplanation),
  vehicleTypeLabel: () => i18n.t(i18nKeys.backgroundCheck__vehicleTypeLabel),
  vehicleDetailTitle: () =>
    i18n.t(i18nKeys.backgroundCheck__vehicleDetailTitle),
  required: () => i18n.t(i18nKeys.common__required),
  birthdate: () => i18n.t(i18nKeys.common__birthdate),
  continue: () => i18n.t(i18nKeys.common__continue),
  socialSecurityNumber: () => i18n.t(i18nKeys.common__socialSecurityNumber),
  confirmSocialSecurityNumber: () =>
    i18n.t(i18nKeys.common__confirmSocialSecurityNumber),
  licenseStateLabel: () => i18n.t(i18nKeys.backgroundCheck__licenseStateLabel),
  licenseStateDisabled: () =>
    i18n.t(i18nKeys.backgroundCheck__licenseStateDisabled),
  licenseNumberLabel: () =>
    i18n.t(i18nKeys.backgroundCheck__licenseNumberLabel),
  insuranceCertificationLabel: () =>
    i18n.t(i18nKeys.backgroundCheck__insuranceCertificationLabel),
  receivesCopy: () => i18n.t(i18nKeys.backgroundCheck__receivesCopy),
  terms: () => i18n.t(i18nKeys.backgroundCheck__terms),
  title: () => i18n.t(i18nKeys.backgroundCheck__title),
  disclosureTitle: () => i18n.t(i18nKeys.backgroundCheck__disclosureTitle),
  disclosureTitleNew: () =>
    i18n.t(i18nKeys.backgroundCheck__disclosureTitleNew),
  backgroundCheckDescription: () =>
    i18n.t(i18nKeys.backgroundCheck__titleDescription),
  backgroundCheckDescriptionNew: (useV2: boolean = false) =>
    useV2
      ? i18n.t(i18nKeys.backgroundCheck__titleDescriptionNewV2)
      : i18n.t(i18nKeys.backgroundCheck__titleDescriptionNew),
  makeLabel: () => i18n.t(i18nKeys.needsVehicleInfo__form__makeLabel),
  modelLabel: () => i18n.t(i18nKeys.needsVehicleInfo__form__modelLabel),
  colorLabel: () => i18n.t(i18nKeys.needsVehicleInfo__form__colorLabel),
  colors: {
    silver: () => i18n.t(i18nKeys.common__color__silver),
    white: () => i18n.t(i18nKeys.common__color__white),
    black: () => i18n.t(i18nKeys.common__color__black),
    blue: () => i18n.t(i18nKeys.common__color__blue),
    gray: () => i18n.t(i18nKeys.common__color__gray),
    red: () => i18n.t(i18nKeys.common__color__red),
    green: () => i18n.t(i18nKeys.common__color__green),
    brown: () => i18n.t(i18nKeys.common__color__brown),
    gold: () => i18n.t(i18nKeys.common__color__gold),
    tan: () => i18n.t(i18nKeys.common__color__tan),
    orange: () => i18n.t(i18nKeys.common__color__orange),
    yellow: () => i18n.t(i18nKeys.common__color__yellow),
    purple: () => i18n.t(i18nKeys.common__color__purple),
  },
  editButtonText: () => i18n.t(i18nKeys.backgroundCheck__editButtonText),
  editDetailsTitle: () => i18n.t(i18nKeys.backgroundCheck__editDetailsTitle),
  detailsPreviewTitle: () =>
    i18n.t(i18nKeys.backgroundCheck__detailsPreviewTitle),
  editDetailsPrimaryAction: () =>
    i18n.t(i18nKeys.backgroundCheck__editDetailsPrimaryAction),
  submissionError: () => i18n.t(i18nKeys.backgroundCheck__submissionError),
  vehicleTypeOther: () => i18n.t(i18nKeys.common__other),
}
